<template>
    <div>
    	<b-carousel 
            ref="viewImg"
            @sliding-start="onSlideStart"
            controls
            indicators
            :interval="4000"
             >
			<b-carousel-slide v-for="(item,key) in Imgs" :img-src="item.url.original" v-bind:key="key"></b-carousel-slide>
	    </b-carousel>
        <ul class="list-thumb-carousel">
            <li v-for="(item,key) in Imgs" @click="activateImage(key)" v-bind:key="key">
                <img :class="[(activeImage == key) ? 'active' : '']" :src="item.url.medium" alt="" >
            </li>
        </ul>
    </div>
</template>
<script>
import Vue from 'vue'

export default {
  name: 'view-img',
    props: {
        Imgs : {
            type: Array,
            default: () => {}
        },
    },
    data: function () {
    return {
          activeImage : 0
        }
    },
     computed: {
            currentImage() {
                return this.Imgs[this.activeImage].url.original;
            }
        },
    methods: {
        activateImage(imageIndex) {
            this.$refs.viewImg.setSlide(imageIndex)
        },
        onSlideStart(slide){
            this.activeImage = slide;
        },
  }
}
</script>

